import { Route } from 'react-router-dom'
import { lazy } from 'react'

const MinorGuardianConsent = lazy(() => import('./pages/MinorGuardianConsent'))
const PatientAccessGranted = lazy(() => import('./pages/PatientAccessGranted'))

const MinorGuardianConsentRoutes = [
  <Route
    path="/termos-resp-legal"
    key="/termos-resp-legal"
    exact
    component={MinorGuardianConsent}
  />,
  <Route
    path="/termos-resp-legal/conta-liberada-com-sucesso/:patientName"
    key="/termos-resp-legal/conta-liberada-com-sucesso/:patientName"
    exact
    component={PatientAccessGranted}
  />,
]

export default MinorGuardianConsentRoutes
